// js
import SecurityDashboardsOtherDetail from '../../components/analytics/SecurityDashboardsOtherDetail';
import { connect } from 'react-redux';
import { getSecurityDashboardsByCategoryInCategoriesWithSingleSubcategory } from '../../selectors/analytics/securitySelectors';


const mapStateToProps = (state) => {
  return {
    categories: getSecurityDashboardsByCategoryInCategoriesWithSingleSubcategory(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityDashboardsOtherDetail);



// WEBPACK FOOTER //
// ./src/containers/analytics/SecurityDashboardsOtherDetail.js